import React from 'react';
import Grid from 'react-bootstrap/lib/Grid';

import Header from '../Header';
import BrowserTitle from '../BrowserTitle';
import Footer from '../Footer';

const Layout = props => (
    <main role="main" className="main-container d-flex flex-column">
        <BrowserTitle title={props.title} />
        <Header />
        <section className="subpage flex-grow-1">
            <Grid>{props.children}</Grid>
        </section>
        <Footer />
    </main>
);

export default Layout;
